'use client';
import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { PropsWithChildren } from 'react';
import { AuthProvider } from 'react-oidc-context';

import { useAnalytics } from '@/hooks/useAnalytics';
import { getGlobalArgs } from '@/root/global';
import { AppNavigationCtxData } from '@/types/navigation';
import { ServerCtxData } from '@/types/server';
import { isClientSide } from '@/utils/next';

import { AppNavigationProvider } from './AppNavigation';
import { ModalsContextProvider } from './Modals';
import { ServerDataContextProvider } from './ServerData';
import { ThemeContextProvider } from './ThemeContext';
import { WithLocale } from './WithLocale';

const OIDC_REDIRECT_URI = getGlobalArgs('NEXT_PUBLIC_OIDC_REDIRECT_URI', 'cloud.ru');

export const OIDC_CONFIG: UserManagerSettings = {
  authority: `${getGlobalArgs('NEXT_PUBLIC_OIDC_AUTHORITY_URL', '')}/auth/system/openid/`,
  client_id: getGlobalArgs('NEXT_PUBLIC_OIDC_CLIENT_ID', ''),
  redirect_uri: OIDC_REDIRECT_URI,
  response_type: 'code',
  scope: 'openid profile',
  userStore: !isClientSide() ? undefined : new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,
};
export function RootProvider({
  children,
  headers,
  appNavigationConfig,
}: PropsWithChildren<ServerCtxData & Pick<AppNavigationCtxData, 'appNavigationConfig'>>) {
  useAnalytics();

  return (
    <AuthProvider {...OIDC_CONFIG}>
      <ThemeContextProvider>
        <AppNavigationProvider appNavigationConfig={appNavigationConfig}>
          <WithLocale>
            <ModalsContextProvider>
              <ServerDataContextProvider headers={headers}>{children}</ServerDataContextProvider>
            </ModalsContextProvider>
          </WithLocale>
        </AppNavigationProvider>
      </ThemeContextProvider>
    </AuthProvider>
  );
}
